import styled from "styled-components";

export const VerticalFormLayout = styled.form<{ $gap?: string }>`
    display: grid;
    grid-auto-flow: row;
    gap: ${({ $gap }) => $gap || "1rem"};
    grid-template-columns: minmax(0, 1fr);
`;
